import { FC, PropsWithChildren } from 'react';
import { ModalContext } from './modal-context';

export const ModalContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ModalContext.Provider value={{}}>
      {children}
    </ModalContext.Provider>
  );
};
